import { Row, Typography } from 'darrius';
import { type IMapReturn } from '../../../modules/profile/shared/pageProps/getMapProps/@interfaces';

import styles from './ProfileLocation.module.scss';

interface IProfileLocationProps {
  location: IMapReturn;
}

export const ProfileLocation = ({ location }: IProfileLocationProps) => {
  if (!location) return null;

  return (
    <Row>
      <section
        className={`${styles.location} space-bottom space-top`}
        id={location.id}
      >
        <Typography.Subtitle
          size="l"
          className={styles['profile-location__title']}
        >
          {location.title}
        </Typography.Subtitle>
        <img src={location.image} alt={location.alt} />
      </section>
    </Row>
  );
};
